import React, { Component, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import styles from "./styles.scss";
import { Footer } from "~/components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import classnames from "classnames";
import { selectors as appSelectors } from "../App";
import { selectors as reservationSelectors } from "../ReservationManager";
import { selectors as modificationSelectors } from "../BookingModification";
import { actions } from "./reducer";
import { withRouter, __RouterContext as RouterContext } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { actions as appActions } from "../App";
import {
  configurationSelector,
  cancelStatusSelector,
  cancellationFormQuestionnaireSelector,
  cancellationRestrictionsConfirmationSelector,
  cancellationPoliciesInfoConfirmationSelector,
  comiNetoSelector,
} from "./selectors";
import {
  currentCancellationPolicyRule,
  executeEvent,
  redirectUrl,
  renderHTML,
  isDeferredReservationInLocalStorage,
  removeDeferredReservationFromLocalStorage,
} from "../../utils/misc";
import constants from "../../utils/constants";
import { ConfirmationPage, WitButton } from "@witbooking/react-components";
import moment from "moment";
import styled from "styled-components";
import media from "../../utils/media";
import { formatTDate } from "../../utils/date";
import { isReservationLoadedSelector } from "../App/selectors";
import { parse as queryStringParse } from "query-string";

const {
  ConfirmationPageMessage,
  ConfirmationPageCard,
  ConfirmationPageButtons,
  ConfirmationPageCustomerInfo,
  ConfirmationPagePropertyInfo,
} = ConfirmationPage;

import { modificationPoliciesSelector } from "../BookingModification/selectors";
import Notification from "../../components/Notification/Notification";
import GlobalLoader from "../../components/GlobalLoader";
import { sendBookInfo } from "../../utils/EngineDataColllector/EngineDataCollector";
import { genericHandleCancellation, genericOnBookingConfirmationMount } from "./utils";
import { defineMessages, FormattedMessage } from "react-intl";
import { createPnPErrorLog } from "../../utils/witbookingApi";

const msg = defineMessages({
  tryAgain: {
    id: "confirmation.tryAgain",
    description: "confirmation.tryAgain",
    defaultMessage: "Try again",
  },
  returnHome: {
    id: "reservationConfirmed.returnHome.button",
    description: "Return home button text",
    defaultMessage: "Back home",
  },
});

const MessageButttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${media.up.mdl`
  grid-template-columns: 6.5fr 3.5fr; grid-column-gap: 30px;`};
`;

const ConfirmationPageMessageButtonsContainer = styled.div`
  padding: 0 10px;
  ${media.up.sml`
    padding: 0;
    & > *:first-child > *:first-child {
    margin-right:10px;
    }
  `};
`;

const StyledNotification = styled(Notification)`
  margin: 10px 0 !important;
`;

const StyledConfirmationPageMessage = styled(ConfirmationPageMessage)`
  margin: 10px 0 !important;
`;

const Pending = styled.div`
  font-size: 25px;
  color: #ff9125;
  line-height: 30px;
  margin-bottom: 20px;
`;

const StyledWitButton = styled(WitButton)`
  min-width: 220px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const selectors = {
  ...appSelectors,
  ...reservationSelectors,
  ...modificationSelectors,
};

class BookingConfirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isConditionsModalOpen: false,
      cancellationError: false,
      loading: false,
    };

    this.handleCancellation = this.handleCancellation.bind(this);
    this.handleChangeLocale = this.handleChangeLocale.bind(this);
    this.handleChangeConfiguration = this.handleChangeConfiguration.bind(this);
    this.handleModification = this.handleModification.bind(this);
    this.handleTryAgain = this.handleTryAgain.bind(this);
  }

  componentDidMount() {
    const clearDataConditionsMet =
      this.props.isAnalyticsLoaded &&
      this.props.isTripAdvisorLoaded &&
      this.props.isExternalMarkupLoaded;

    const reservationId = this.props.reservation && this.props.reservation.get("id");
    const isDeferredReservation = isDeferredReservationInLocalStorage(
      this.props.propertyTicker,
      reservationId
    );
    const reservationStatusConfirmed =
      (this.props.reservationCreated || isDeferredReservation) &&
      this.props.reservation &&
      this.props.reservation.get("roomReservations") &&
      this.props.reservation
        .get("roomReservations")
        .some(reservation => reservation.get("status") === constants.RESERVATION_STATUS.CONFIRMED);

    if (reservationStatusConfirmed && isDeferredReservation) {
      removeDeferredReservationFromLocalStorage(
        this.props.propertyTicker,
        this.props.reservation.get("id")
      );
    }

    genericOnBookingConfirmationMount(
      clearDataConditionsMet,
      this.props.clearData,
      this.props.getCountries,
      this.props.locale,
      reservationStatusConfirmed,
      this.props.reservation,
      this.props.propertyTicker,
      this.props.defaultCurrency,
      this.props.comiNeto
    );

    const pendingTryAgain =
      (this.props.reservation.get("paymentMethod") === constants.PAYMENT_TYPES.CREDIT_CARD_VAULT ||
        this.props.reservation.get("paymentMethod") ===
          constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY) &&
      this.props.reservation
        .get("roomReservations")
        .some(it => it.get("status") === constants.RESERVATION_STATUS.PRE_RESERVATION);
    if (pendingTryAgain) {
      createPnPErrorLog({
        reservationId: this.props.reservation.get("id"),
        rawEvent: JSON.stringify({
          additionalData: {
            propertyTicker: this.props.propertyTicker,
            paymentMethod: this.props.reservation.get("paymentMethod"),
          },
        }),
        message: "Landed in booking confirmation when reservation is pending",
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.isTripAdvisorLoaded !== this.props.isTripAdvisorLoaded ||
        prevProps.isExternalMarkupLoaded !== this.props.isExternalMarkupLoaded) &&
      this.props.isTripAdvisorLoaded &&
      this.props.isExternalMarkupLoaded
    ) {
      this.props.clearData();
    }
  }

  componentWillUnmount() {
    this.props.handleExpandPromotions(false);
  }

  handleModification(reservationId) {
    this.props.history.push(`/${this.props.propertyTicker}/booking-modification/${reservationId}/`);
  }

  handleChangeConfiguration(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
  }

  handleChangeLocale(newConfiguration) {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: newConfiguration,
    });
    this.props.changeLocale({
      propertyTicker: this.props.propertyTicker,
      locale: newConfiguration.locale,
    });
  }

  handleCancellation({ reservation, roomStayId, cancellationReason, quantity, defaultCurrency }) {
    const promise = this.props.cancelBook({
      hotelTicker: this.props.propertyTicker,
      reservationId: roomStayId,
      cancellationReason,
    });
    const stateUpdateOnError = () => {
      if (!this.state.cancellationError) {
        this.setState({ cancellationError: true, loading: false });
      }
    };

    genericHandleCancellation(
      promise,
      stateUpdateOnError,
      reservation,
      roomStayId,
      quantity,
      defaultCurrency
    );
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
  }

  handlePrint = () => {
    if (window) {
      window.print();
    }
  };

  handleBackButton = () => {
    if (this.props.hotelSiteURL) {
      redirectUrl(this.props.hotelSiteURL);
    } else if (document.referrer) {
      redirectUrl(document.referrer);
    }
  };

  handleTryAgain = () => {
    redirectUrl(`/${this.props.hotelTicker}/${constants.STEP_PATHS.STEP_1}`);
  };

  render() {
    const {
      handleCancellation,
      handleChangeLocale,
      handleChangeConfiguration,
      handleModification,
    } = this;
    const {
      reservation,
      propertyContact,
      propertyName,
      configuration,
      handleModalContent,
      defaultCurrency,
      pendingAmountTextConfiguration,
      fullWidth,
      generateMapView,
      currency,
      handleCloseModal,
      showElementsConfig,
      isAgent,
      affiliate,
      locale,
      availableLocales,
      availableCurrencies,
      promoCode,
      toggleBookingFormSummary,
      cancellationFormQuestionnaire,
      cancellationRestrictionsConfirmation,
      cancellationPoliciesInfo,
      countries,
      modificationPolicies,
      messages,
      addObligatoryExtrasRateToRoomSelection,
    } = this.props;

    const doStatusDiffer = reservation
      .get("roomReservations")
      .some(res =>
        reservation
          .get("roomReservations")
          .some(innerRes => innerRes.get("status") !== res.get("status"))
      );

    const pendingTryAgain =
      (reservation.get("paymentMethod") === constants.PAYMENT_TYPES.CREDIT_CARD_VAULT ||
        reservation.get("paymentMethod") === constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY) &&
      reservation
        .get("roomReservations")
        .some(
          reservation => reservation.get("status") === constants.RESERVATION_STATUS.PRE_RESERVATION
        );

    const pendingTryAgainMessage = (
      <div>
        <Pending>
          <FormattedMessage {...msg.tryAgain} />
        </Pending>
        <ButtonWrapper>
          <StyledWitButton type="grey" onClick={this.handleTryAgain}>
            <FormattedMessage {...msg.returnHome} />{" "}
          </StyledWitButton>
        </ButtonWrapper>
      </div>
    );

    const customerCountry =
      countries &&
      reservation &&
      countries.find(country => country.get("code") === reservation.get("customer").get("country"));
    const totalActiveReservations = reservation
      .get("roomReservations")
      .filter(it => it.get("status") === constants.RESERVATION_STATUS.CONFIRMED).size;
    return (
      <Grid>
        <div className={classnames("wbkv9-BookingConfirmation-Reservations")}>
          {pendingTryAgain
            ? pendingTryAgainMessage
            : reservation.get("roomReservations").map((res, idx) => (
                <div key={idx}>
                  <ConfirmationPageMessageButtonsContainer>
                    {(idx === 0 || doStatusDiffer) && (
                      <MessageButttons>
                        <StyledConfirmationPageMessage reservationStatus={res.get("status")} />
                        {idx === 0 && (
                          <ConfirmationPageButtons
                            handlePrint={this.handlePrint}
                            handleBackButton={this.handleBackButton}
                          />
                        )}
                      </MessageButttons>
                    )}
                  </ConfirmationPageMessageButtonsContainer>
                  {idx === 0 &&
                    messages &&
                    messages.get("CONFIRMATION_PAGE") &&
                    messages.get("CONFIRMATION_PAGE").size > 0 &&
                    messages
                      .get("CONFIRMATION_PAGE")
                      .map((it, index) => (
                        <StyledNotification
                          key={index}
                          id={it.get("id")}
                          position={it.get("position")}
                          text={<span dangerouslySetInnerHTML={renderHTML(it.get("content"))} />}
                          type={it.get("type").toLowerCase()}
                          borderRadius
                          closeIcon
                        />
                      ))}
                  <ConfirmationPageCard
                    additionalRequests={res.get("additionalRequests")?.toJS()}
                    hotelSiteURL={this.props.hotelSiteURL}
                    dailyValues={res.get("dailyValues").toJS()}
                    subtotal={res.get("subTotalAmount").get("amount")}
                    total={res.get("totalAmount").get("amount")}
                    deposit={res.get("guaranteeAmount").get("amount")}
                    extras={res.get("selectedServices").toJS()}
                    discounts={res.get("discounts").toJS()}
                    displayDailyRates={configuration.displayDailyRates}
                    defaultCurrency={defaultCurrency}
                    pendingAmountTextConfiguration={pendingAmountTextConfiguration}
                    bookingId={res.get("confirmationId")}
                    status={res.get("status")}
                    reference={reservation.get("id")}
                    received={formatTDate(reservation.get("placementDate"))}
                    checkIn={res.get("checkIn")}
                    checkOut={res.get("checkOut")}
                    mealPlan={res.get("mealPlan")}
                    restrictions={cancellationRestrictionsConfirmation[idx]}
                    cutOffDate={moment(reservation.get("placementDate")).toDate()}
                    toPay={
                      res.get("totalAmount").get("amount") -
                      res.get("guaranteeAmount").get("amount")
                    }
                    guests={res.get("capacity") * res.get("quantity")}
                    handleCancellation={cancellationReason =>
                      handleCancellation({
                        reservation: reservation,
                        roomStayId: res.get("confirmationId"),
                        cancellationReason,
                        quantity: res.get("quantity"),
                        defaultCurrency,
                      })
                    }
                    handleModification={() => handleModification(res.get("confirmationId"))}
                    property={propertyName}
                    backgroundColor={
                      "#" + this.props.customStyles.get("bookingFormButtonBackgroundColor")
                    }
                    textColor={"#" + this.props.customStyles.get("bookingFormButtonOppositeColor")}
                    accommodationQuantity={res.get("quantity")}
                    accommodationType={res.get("accommodationType")}
                    packageName={res.get("packageName")}
                    conditions={res.get("condition").toJS()}
                    firstNightCost={res.get("firstNightCharge")}
                    currency={defaultCurrency}
                    showCancellationTable
                    cancellationFormQuestionnaire={cancellationFormQuestionnaire}
                    handlePrint={this.handlePrint}
                    handleBackButton={this.handleBackButton}
                    cancellationError={this.state.cancellationError}
                    loading={this.state.loading}
                    cancellationPoliciesInfo={
                      cancellationPoliciesInfo && cancellationPoliciesInfo[idx]
                    }
                    currentPolicyAllowsCancel={
                      cancellationRestrictionsConfirmation &&
                      cancellationRestrictionsConfirmation[idx] &&
                      currentCancellationPolicyRule(cancellationRestrictionsConfirmation[idx])
                        .cancelOnline
                    }
                    hasModificationPolicies={
                      modificationPolicies.size > 0 &&
                      modificationPolicies.some(policy =>
                        policy.get("conditionRates").some(cr => cr === res.get("conditionTicker"))
                      )
                    }
                    addObligatoryExtrasRateToRoomSelection={addObligatoryExtrasRateToRoomSelection}
                    taxesText={this.props.taxesText}
                    totalActiveReservations={totalActiveReservations}
                  />
                </div>
              ))}
        </div>
        <div>
          <ConfirmationPageCustomerInfo
            name={reservation.get("customer").get("name")}
            surname={reservation.get("customer").get("lastName")}
            email={reservation.get("customer").get("email")}
            phone={reservation.get("customer").get("phone")}
            country={customerCountry && customerCountry.get("name")}
            personalId={reservation.get("customer").get("documentId")}
            address={reservation.get("customer").get("address")}
            backgroundColor={"#" + this.props.customStyles.get("bookingFormButtonBackgroundColor")}
            textColor={"#" + this.props.customStyles.get("bookingFormButtonOppositeColor")}
          />
          <ConfirmationPagePropertyInfo
            email={propertyContact.get("contactEmail")}
            address={propertyContact.get("address")}
            phone={propertyContact.get("phone")}
            name={propertyName}
            src={this.props.media.size > 0 && this.props.media.get("0").get("url")}
            backgroundColor={"#" + this.props.customStyles.get("bookingFormButtonBackgroundColor")}
            textColor={"#" + this.props.customStyles.get("bookingFormButtonOppositeColor")}
          />
        </div>
        <div className={classnames("wbkv9-RoomSelection-Footer", "wbkv9-Footer", styles.footer)}>
          <Footer
            fullWidth={fullWidth}
            isAgentLogged={isAgent}
            affiliate={affiliate}
            propertyName={propertyName}
            propertyContact={propertyContact}
            handleMap={() =>
              handleModalContent(generateMapView(true), {
                mobileMode: true,
                className: "wbkv9-Modal-mapModal",
              })
            }
            showLanguage={showElementsConfig.showLanguageSelector}
            showCurrency={false}
            locale={locale}
            currency={currency}
            locales={availableLocales}
            currencies={availableCurrencies}
            onLanguageChange={handleChangeLocale}
            onCurrencyChange={handleChangeConfiguration}
            promoCode={promoCode}
            handleModalContent={handleModalContent}
            handleCloseModal={handleCloseModal}
            toggleBookingFormSummary={toggleBookingFormSummary}
            showAgentLogin={this.props.showAgentLogin}
          />
        </div>
      </Grid>
    );
  }
}

BookingConfirmation.propTypes = {
  reservation: PropTypes.object.isRequired,
  clearData: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  propertyTicker: PropTypes.string,
  addAlert: PropTypes.func,
  cancelBook: PropTypes.func,
  cancelLoaded: PropTypes.bool,
  cancelError: PropTypes.bool,
  cancelLoading: PropTypes.bool,
  cancelRelease: PropTypes.number,
  configuration: PropTypes.object,
  currency: PropTypes.string,
  defaultCurrency: PropTypes.string,
  propertyContact: PropTypes.object,
  propertyName: PropTypes.string,
  handleModalContent: PropTypes.func,
  pendingAmountTextConfiguration: PropTypes.string,
  generateMapView: PropTypes.func,
  media: PropTypes.object,
  handleCloseModal: PropTypes.func,
  showElementsConfig: PropTypes.object,
  isAgent: PropTypes.bool,
  affiliate: PropTypes.string,
  availableLocales: PropTypes.object,
  availableCurrencies: PropTypes.object,
  promoCode: PropTypes.string,
  toggleBookingFormSummary: PropTypes.func,
  cancellationFormQuestionnaire: PropTypes.array,
  cancellationRestrictionsConfirmation: PropTypes.object,
  cancellationPoliciesInfo: PropTypes.object,
  fullWidth: PropTypes.bool,
  isAnalyticsLoaded: PropTypes.bool,
  isTripAdvisorLoaded: PropTypes.bool,
  isExternalMarkupLoaded: PropTypes.bool,
  reservationCreated: PropTypes.bool,
  handleExpandPromotions: PropTypes.func,
  changeConfiguration: PropTypes.func,
  getCountries: PropTypes.func,
  changeLocale: PropTypes.func,
  ARI: PropTypes.object,
  hotelSiteURL: PropTypes.string,
  showAgentLogin: PropTypes.bool,
  customStyles: PropTypes.object,
  modificationPolicies: PropTypes.object,
  countries: PropTypes.array,
  messages: PropTypes.object,
  addObligatoryExtrasRateToRoomSelection: PropTypes.bool,
};

const ConnectedBookingConfirmation = connect(
  createStructuredSelector({
    pendingAmountTextConfiguration: selectors.pendingAmountTextConfigurationSelector,
    addObligatoryExtrasRateToRoomSelection:
      selectors.addObligatoryExtrasRateToRoomSelectionSelector,
    reservation: selectors.reservationSelector,
    locale: selectors.localeSelector,
    propertyTicker: selectors.propertyTickerSelector,
    propertyContact: selectors.propertyContactSelector,
    propertyName: selectors.propertyNameSelector,
    cancelRelease: selectors.cancelReleaseSelector,
    countries: selectors.countriesSelector,
    configuration: configurationSelector,
    currency: selectors.currencySelector,
    defaultCurrency: selectors.defaultCurrencySelector,
    isAnalyticsLoaded: selectors.analyticsLoadedSelector,
    isTripAdvisorLoaded: selectors.tripAdvisorLoadedSelector,
    isExternalMarkupLoaded: selectors.externalMarkupLoadedSelector,
    cancelStatus: cancelStatusSelector,
    fullWidth: selectors.fullWidthSelector,
    media: selectors.mediaSelector,
    creditCardTypes: selectors.creditCardTypesSelector,
    reservationCreated: selectors.reservationCreatedSelector,
    iframeMode: selectors.iframeModeSelector,
    showElementsConfig: selectors.showElementsConfigSelector,
    availableLocales: selectors.availableLocalesSelector,
    availableCurrencies: selectors.availableCurrenciesSelector,
    promoCode: selectors.promoCodeSelector,
    hotelSiteURL: selectors.hotelSiteURLSelector,
    isAgent: selectors.isAgentSelector,
    affiliate: selectors.affiliateSelector,
    showAgentLogin: selectors.showAgentLoginSelector,
    isReservationModifiable: selectors.isReservationModifiableSelector,
    cancellationFormQuestionnaire: cancellationFormQuestionnaireSelector,
    ARI: selectors.propertyARISelector,
    cancellationRestrictionsConfirmation: cancellationRestrictionsConfirmationSelector,
    customStyles: selectors.customStylesSelector,
    cancellationPoliciesInfo: cancellationPoliciesInfoConfirmationSelector,
    modificationPolicies: modificationPoliciesSelector,
    messages: selectors.messagesSelector,
    taxesText: selectors.taxesTextSelector,
    comiNeto: selectors.comiNetoSelector,
  }),
  dispatch => bindActionCreators({ ...actions, ...appActions }, dispatch)
)(withRouter(BookingConfirmation));

export default function (props) {
  const isReservationLoaded = useSelector(isReservationLoadedSelector);
  const dispatch = useDispatch();
  const router = useContext(RouterContext);
  useEffect(() => {
    if (!isReservationLoaded) {
      const query =
        (router.location && router.location.search && queryStringParse(router.location.search)) ||
        {};
      const urlParams = {
        hotelTicker: props.hotelTicker,
        reservationId: props.reservationId,
        ...query,
      };
      dispatch(appActions.requestReservationData(urlParams));
    }
  }, []);

  return isReservationLoaded ? <ConnectedBookingConfirmation {...props} /> : <GlobalLoader />;
}
